import { isDev } from './index'

const mainShare = {
  // any thing share to plugin

  isTest() {
    return window.location.host.includes('dev-lane') || isDev
  },
}
export type MainShare = typeof mainShare
export default mainShare
